const SHOW = 'pulp/errorPage/SHOW';
const HIDE = 'pulp/errorPage/HIDE';

export const initialState = {
  display: false,
  status: null,
};

export default function reducer(state = initialState, action) {
  if (action.type === SHOW) {
    return {...state, display: true, ...action.payload};
  } else if (action.type === HIDE) {
    return {...state, display: false, status: null};
  }
  return state;
}

export function showErrorPage(payload) {
  return {
    type: SHOW,
    payload: payload
  };
}

export function hideErrorPage() {
  return {
    type: HIDE
  };
}